import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offer-card" }
const _hoisted_2 = { class: "offer-image-container" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "offer-content" }
const _hoisted_5 = { class: "offer-title" }
const _hoisted_6 = { class: "offer-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.getImageSrc(_ctx.offer),
        alt: _ctx.offer.title,
        class: "offer-image"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.offer.title), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.offer.description), 1)
    ])
  ]))
}